import * as Sentry from '@sentry/react';

import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { CopyAllRounded } from '@mui/icons-material';

import SentryError from '@/shared/assets/icons/sentry-fallback.svg?react';

import { showToast } from '../../../utils/toast';

import { ButtonUi } from '../Button/Button';
import { AppImage } from '../AppImage/AppImage';
import { sentryFallbackStyle } from './style';

export const SentryFallback = (props) => {
  const {
    error,
    eventId,
    resetError,
    onRetry,
    homeHref = '/admin/dashboard',
    title = 'sentry.fallback.title',
    subtitle = 'sentry.fallback.subtitle',
  } = props;
  const { sentryFallback } = sentryFallbackStyle;
  const { t } = useTranslation();
  const history = useHistory();

  const retry = resetError || onRetry || (() => window.location.reload());

  const report = () => {
    Sentry.showReportDialog({ eventId });
  };

  const copyId = async () => {
    if (!eventId) return;
    await navigator.clipboard.writeText(eventId);
    showToast(t('sentry.fallback.reference-copied'), 'success', 3000);
  };

  const goHome = () => {
    onRetry?.();
    history?.push({
      pathname: homeHref,
    });
  };

  return (
    <Box sx={sentryFallback} className='sf-page'>
      <AppImage className='logo' src='/assets/psylaris-logo-full.png' />
      <Box className='sf-card' role='alert' aria-live='assertive'>
        <SentryError className='error-icon' />
        <Typography variant='h1' className='sf-title'>
          {t(title)}
        </Typography>
        <Typography variant='h4' className='sf-subtitle'>
          {t(subtitle)}
        </Typography>

        {!!eventId && (
          <Typography variant='h6' className='sf-ref'>
            {t('sentry.fallback.reference')}:{' '}
            <code>#{eventId.slice(0, 8)}</code>
            <ButtonUi
              isIconBtn
              className='sf-link'
              size='small'
              tooltipTitle={t('buttons.click-to-copy')}
              onClickHandler={copyId}
            >
              <CopyAllRounded />
            </ButtonUi>
          </Typography>
        )}

        <Box className='sf-actions'>
          <ButtonUi
            className='sf-reload'
            variant='contained'
            type='primary'
            size='small'
            onClickHandler={() => window.location.reload()}
          >
            {t('buttons.reload-page')}
          </ButtonUi>
          <ButtonUi
            className='sf-home'
            variant='outlined'
            type='secondary'
            size='small'
            onClickHandler={goHome}
          >
            {t('buttons.go-to-dashboard')}
          </ButtonUi>
          <ButtonUi
            className='sf-report'
            variant='outlined'
            type='secondary'
            size='small'
            onClickHandler={report}
          >
            {t('buttons.report-issue')}
          </ButtonUi>
        </Box>
      </Box>
    </Box>
  );
};
